var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"grid gap-x-1.5 md:gap-x-5 md:gap-y-30px",class:{
    'grid-cols-1': _vm.spCols === 1,
    'grid-cols-2': _vm.spCols === 2,
    'md:grid-cols-3': _vm.pcCols === 3,
    'md:grid-cols-4': _vm.pcCols === 4,
    'md:grid-cols-5': _vm.pcCols === 5,
    'gap-y-15px': _vm.spVerticalGap === 15,
    'gap-y-30px': _vm.spVerticalGap === 30,
    'md:gap-y-30px': _vm.pcVerticalGap === 30,
    'md:gap-y-60px': _vm.pcVerticalGap === 60,
  }},_vm._l((_vm.items),function(item,index){return _c('li',{key:item[_vm.keyProperty]},[_vm._t("default",null,{"item":item,"index":index})],2)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }